export default "__VITE_ASSET__b40e756f__"